export default "__VITE_ASSET__143951c7__"